import React from 'react';

import { AlertDialog, AlertDialogProps, ColorPalette, Text } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

export interface BlockedRedirectionDialogProps extends Pick<AlertDialogProps, 'kind'> {
    // The title of the dialog
    title?: string;
    // The description of the dialog
    description?: string;
    // The label of the confirm button
    confirmLabel?: string;
    // The label of the cancel button
    cancelLabel?: string;
    // Whether the dialog is open
    isOpen: boolean;
    // The callback triggered when clicking the cancel button
    onCancel(): void;
    // The callback triggered when clicking the confirm button
    onConfirm(): void;
}

const BlockedRedirectionDialog: React.FC<BlockedRedirectionDialogProps> = ({
    isOpen,
    title,
    description,
    confirmLabel,
    cancelLabel,
    onCancel,
    onConfirm,
    ...props
}) => {
    const { translateKey } = useTranslate();
    return (
        <AlertDialog
            kind="warning"
            confirmProps={{
                onClick: onConfirm,
                label: confirmLabel || translateKey(GLOBAL.CONTINUE),
                color: ColorPalette.yellow,
            }}
            cancelProps={{
                onClick: onCancel,
                label: cancelLabel || translateKey(GLOBAL.CANCEL),
            }}
            title={title || translateKey(GLOBAL.UNSAVED_MODIFICATIONS)}
            isOpen={isOpen}
            {...props}
        >
            <Text as="p" typography="body1">
                {description || translateKey(GLOBAL.UNSAVED_MODIFICATIONS_DESCRIPTION)}
            </Text>
        </AlertDialog>
    );
};

export { BlockedRedirectionDialog };
